import React from "react";
import I18n from "i18n-js";

import ProgressBar from "../../../commons/ProgressBar";

const TaskProgress = ({ task }) => {
  const progress = task?.progress ? Math.min(Math.max(0, Math.round(task.progress * 100)), 100) : 0;

  return (
    <div className="task-progress">
      <span className="status">{I18n.t("pdp.objectives.task.info.progress.status", { progress: progress })}</span>
      <ProgressBar value={progress} />
    </div>
  );
}

export default TaskProgress;
